import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { loadModules } from 'esri-loader';
import esri = __esri; // Esri TypeScript Types

@Component({
  selector: 'app-esri-map',
  templateUrl: './esri-map.component.html',
  styleUrls: ['./esri-map.component.css', '../../styles/main2.css']
})
export class EsriMapComponent implements OnInit {

  @Output() mapLoadedEvent = new EventEmitter<boolean>();

  // The <div> where we will place the map
  @ViewChild('mapViewNode') private mapViewEl: ElementRef;

  private _zoom = 10;
  private _center: Array<number> = [0.1278, 51.5074];
  private _basemap = 'streets';
  private _loaded = false;

  get mapLoaded(): boolean {
    return this._loaded;
  }

  @Input()
  set zoom(zoom: number) {
    this._zoom = zoom;
  }

  get zoom(): number {
    return this._zoom;
  }

  @Input()
  set center(center: Array<number>) {
    this._center = center;
  }

  get center(): Array<number> {
    return this._center;
  }

  @Input()
  set basemap(basemap: string) {
    this._basemap = basemap;
  }

  get basemap(): string {
    return this._basemap;
  }

  constructor() { }
/*

    var map = new EsriMap({
      basemap: "topo"
    });

    // Create the MapView and reference the Map in the instance
    var view = new MapView({
      container: "viewDiv",
      map: map,
      center: [-86.049, 38.485],
      zoom: 3
    });


*/
  
  async initializeMap() {
    try {

      // Load the modules for the ArcGIS API for JavaScript
      const [EsriMap, EsriMapView, BasemapToggle, ScaleBar, Home, Locate, Graphic] = await loadModules([
        'esri/Map',
        'esri/views/MapView',
        'esri/widgets/BasemapToggle',
        'esri/widgets/ScaleBar',
        'esri/widgets/Home',
        'esri/widgets/Locate',
        'esri/Graphic'
      ]);

      // Configure the Map
      const mapProperties: esri.MapProperties = {
        basemap: this._basemap
      };

      const map: esri.Map = new EsriMap(mapProperties);

      // Initialize the MapView
      const mapViewProperties: esri.MapViewProperties = {
        container: this.mapViewEl.nativeElement,
        center: this._center,
        zoom: this._zoom,
        map: map
      };

      const mapView = new EsriMapView(mapViewProperties);

      var toggle = new BasemapToggle({
        view: mapView,
        nextBasemap: "streets"
      });
      mapView.ui.add(toggle, "top-right");

      const scale = new ScaleBar({ view: mapView });
      mapView.ui.add(scale, { position: "bottom-left" } );

      const locateWidget = new Locate({
        viewModel: {
          view: mapView,
          graphic: new Graphic({ symbol: { type: "simple-marker" } })
        }
      });
      mapView.ui.add(locateWidget, "top-left");

      const homeWidget = new Home({ view: mapView });
      mapView.ui.add(homeWidget, "top-left");

      return mapView;
    } catch (error) {
      console.log('EsriLoader: ', error);
    }
  }

  // Finalize a few things once the MapView has been loaded
  houseKeeping(mapView) {
    mapView.when(() => {
      console.log('mapView ready: ', mapView.ready);
      this._loaded = mapView.ready;
      this.mapLoadedEvent.emit(true);
    });
  }

  ngOnInit() {
    // Initialize MapView and return an instance of MapView
    this.initializeMap().then((mapView) => {
      this.houseKeeping(mapView);
    });
  }

}
